import React from 'react'
import PropTypes from 'prop-types'


const FilterInput = ({ filterSetting, changeFilter, columnName, filter }) => {
    if (filterSetting && filterSetting.type !== 'input') {
        return null
    }
    const { beforeQuery, beforeRender } = filterSetting || {}
    const changeInput = (event) => {
        const value = beforeQuery ? beforeQuery(event.currentTarget.value) : event.currentTarget.value
        changeFilter(columnName, value)
    }
    return (
        <div className="inner-addon left-addon right-addon">
            <i className="fa fa-filter"/>
            <i className="fa fa-times-circle" onClick={() => {
                changeFilter(columnName, '')
            }}/>
            <input
                type="text"
                autoCorrect="Off"
                className="form-control"
                onChange={changeInput}
                value={beforeRender ? beforeRender(filter[columnName] || '') : filter[columnName] || ''}
            />
        </div>
    )
}

FilterInput.propTypes = {
    changeFilter: PropTypes.func.isRequired,
    filter: PropTypes.object.isRequired,
    columnName: PropTypes.string.isRequired,
    filterSetting: PropTypes.object,
}

export default FilterInput



// WEBPACK FOOTER //
// ./src/modules/table/component/FilterInput.js